import { useQuery } from '@tanstack/react-query'

import { patientInstance } from '../..'

export function getListPatientsQueryKey({
  personaId,
  personaType
}: {
  personaId?: string
  personaType?: string
}) {
  return ['listPatients', { personaId, personaType }]
}

export function useListPatientsQuery({
  personaId,
  personaType,
  enabled
}: {
  personaId: string
  personaType?: string
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getListPatientsQueryKey({ personaId, personaType }),
    queryFn:
      personaType === 'OPERATIONAL'
        ? async () => await patientInstance.getOperatorPatientList()
        : personaType === 'THERAPIST'
          ? async () => await patientInstance.getTherapistPatientList(personaId)
          : async () => await patientInstance.getResponsiblePatientList(),
    enabled: !!personaType && enabled,
    staleTime: 30 * 60 * 1000 // 30 minutes
  })
}
